



































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { State, Action, Getter } from 'vuex-class';

import Alert from '@/components/Global/Alert.vue';
import TextField from '@/components/Form/TextField.vue';
import SelectField from '@/components/Form/SelectField.vue';
import { Organization } from '../../../../common/Organizations';
import AccordionItem from '@/components/Global/Accordion/AccordionItem.vue';

@Component({
	name: 'ClientIds',
	components: {
		TextField,
		SelectField,
		Alert,
		AccordionItem,
	},
})
export default class ClientIds extends Vue {
	@State('organization', { namespace: 'Organizations' }) private organization: Organization;
	@Getter('clientIds', { namespace: 'Organizations' }) private clientIds: {
		[index: string]: {
			name: string;
			brand: string;
			policies: string[];
			client_id?: string;
		};
	};
	@Action('addClientId', { namespace: 'Organizations' }) private addClientId!: any;
	@Action('refreshClientIds', { namespace: 'Organizations' }) private refreshClientIds!: any;
	private paginate: string[] = ['clientIds'];
	private error: boolean | string = false;
	private success: boolean | string = false;
	private refreshSuccess: boolean = false;
	private refreshError: boolean = false;

	private form: {
		client_id: string;
		brand: string;
	} = {
		client_id: '',
		brand: '',
	};

	private fields: Organization = {
		org_id: '',
		org_name: '',
		is_agency: false,
		brokerageId: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: '',
			state: '',
			zipcode: '',
		},
		client_ids: {},
		phone_number: '',
		invites: [],
		claims: [],
	};

	@Watch('organization', { deep: true })
	private watchOrganization() {
		this.fields = this.organization;
	}

	get paginatedClientIds() {
		const oldList = this.clientIds;
		const clientIds = Object.keys(this.clientIds).map((clientId: string) => {
			oldList[clientId].client_id = clientId;

			return oldList[clientId];
		});

		return clientIds;
	}

	private created() {
		this.fields = this.organization;
		// this.client_ids = this.fields.client_ids;
	}

	/**
	 * Submit the new client id to the backend and return the results
	 */
	private async submitAddClientId(): Promise<void> {
		const data: {
			client_id?: string;
			org_id?: string;
			brand?: string;
		} = {};

		data.client_id = this.form.client_id;
		data.org_id = this.organization.org_id;
		data.brand = this.form.brand;

		try {
			const addClientId = await this.addClientId(data);

			this.success = addClientId;
		} catch (e) {
			this.error = e;
		}
	}

	/**
	 * Fetch new policies for a client id
	 * @TODO
	 */
	private async fetchNewPolicies(): Promise<void> {
		this.refreshSuccess = false;
		this.refreshError = false;

		try {
			await this.refreshClientIds(this.organization.org_id);
			this.refreshSuccess = true;
		} catch (e) {
			console.log(e);
			this.refreshError = true;
		}
	}
}
